import './index.erb';
import './components/card_option';
import './components/card_benefits';
import './components/footer';
import './components/choose';
import './components/advantages';
import './components/options';
import './components/discipline';
import './components/print';
import './components/overview';
import './components/hero';
import './components/meet';
import './components/details';
import './components/related';

// Reaproveitando o código que o Rômulo fez na LP de lançamentos

// Scroll para o form
function scrollToAnchor() {
  var aTag = $('#compre-agora');
  $('html,body').animate({
    scrollTop: aTag.offset().top
  }, 'slow');
}

// tive que interceptar o evento de click do TL pq ele tava dando refresh
$(document).on('turbolinks:click', function (event) {
  if (event.target.getAttribute('href') === '#compre-agora') {
    scrollToAnchor();
    return event.preventDefault();
  }
});

